export default __webpack_public_path__ + "static/media/oi_0.fc12b956.mp3";